import { AnalyticsService } from '@io/services';

import { Directive, ElementRef, HostListener, inject, Input } from '@angular/core';

import { ClickAnalyticsData } from '@ap/analytics';

@Directive({
    standalone: true,
    selector: '[apAnalyticsClick]'
})
export class AnalyticsClickDirective {
    @Input() elementType: string;
    @Input() key?: string;

    @HostListener('click') onClick(): void {
        this.sendAnalytics();
    }

    private readonly elementRef = inject(ElementRef);
    private readonly analyticsService = inject(AnalyticsService);

    sendAnalytics(): void {
        this.analyticsService.push(
            new ClickAnalyticsData(this.elementType, this.key ? this.key : this.elementRef.nativeElement.textContent)
        );
    }
}
